export const produto = `
query ($payload: ilastlimit) {
  GetProdutoPainel (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    destaque,
    dateCreate,
    caracter {
      id,
      name
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const pedidos = `
query ($payload: ilastlimit) {
  GetPedido (payload: $payload) {
    pedido {
      id,
      status,
      usuario {
        id,
        nome,
        sobrenome,
        usuario,
        email,
        status
      },
      dateCreate,
      itens {
        id,
        code,
        img {
          id,
          img
        },
        name,
        status,
        preco,
        oferta,
        qtda,
        pedidoitematributos {
          name,
          value
        }
      },
      gift,
      giftvalor,
      frete,
      notas,
      paymentid
    },
    endereco {
      id,
      cpf,
      celular,
      cep,
      endereco,
      bairro,
      numero,
      cidade,
      uf
    }
  }
}
`
export const SearchProduto = `
query ($payload: String) {
  SearchNameProd (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    destaque,
    dateCreate,
    caracter {
      id,
      name
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const gift = `
query ($payload: ilastlimit) {
  GetGift (payload: $payload) {
    id,
    codigo,
    tipo,
    valor,
    validade,
    gastoMin,
    gastoMax,
    emails,
    limiteCupom,
    limiteNprodutos,
    limiteUser,
    freteGratis,
    individual,
    itensVendaDel,
    categorias {
      id,
      active,
      name,
      icon
    },
    categoriasDel {
      id,
      active,
      name,
      icon
    },
    produtos {
      id,
      code,
      tipo,
      name,
      link,
      status,
      preco,
      oferta,
      img {
        id,
        img
      },
      descricao,
      dateOfertaStart,
      dateOfertaEnd,
      categoria,
      gerEstoque,
      statusEstoque,
      estoque,
      pendencia,
      visibilidade,
      visualizacao,
      destaque,
      atributos {
        active,
        id,
        name,
        values {
          active,
          id,
          name,
          selected
        }
      },
      estoqueVariavel {
        id,
        src {
          quantidade,
          values {
            id,
            idParent,
            name,
            value
          }
        }
      },
      dateCreate,
      caracter {
        id,
        name
      },
      qtda
    },
    produtoDel {
      id,
      code,
      tipo,
      name,
      link,
      status,
      preco,
      oferta,
      img {
        id,
        img
      },
      descricao,
      dateOfertaStart,
      dateOfertaEnd,
      categoria,
      gerEstoque,
      statusEstoque,
      estoque,
      pendencia,
      visibilidade,
      visualizacao,
      destaque,
      atributos {
        active,
        id,
        name,
        values {
          active,
          id,
          name,
          selected
        }
      },
      estoqueVariavel {
        id,
        src {
          quantidade,
          values {
            id,
            idParent,
            name,
            value
          }
        }
      },
      dateCreate,
      caracter {
        id,
        name
      },
      qtda
    }
  }
}
`
export const searchprodutopainel = `
query ($payload: String) {
  SearchNameProdPainel (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    destaque,
    dateCreate,
    caracter {
      id,
      name
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const searchclientpainel = `
query ($payload: String) {
  SearchClientPainel (payload: $payload) {
    usuario {
      id,
      nome,
      sobrenome,
      usuario,
      email,
      status
    },
    endereco {
      id,
      cpf,
      celular,
      cep,
      endereco,
      bairro,
      numero,
      cidade,
      uf
    },
    pedidos {
      id,
      status,
      dateCreate,
      frete,
      gift,
      giftvalor,
      itens {
        id,
        name,
        img {
          id,
          img
        },
        preco,
        qtda
      }
    },
    valorTotalPedidos
  }
}
`
export const searchpedidopainel = `
query ($payload: String){
  SearchPedidoPainel (payload: $payload) {
    pedido {
      id,
      status,
      usuario {
        id,
        nome,
        sobrenome,
        usuario,
        email,
        status
      },
      dateCreate,
      itens {
        id,
        code,
        img {
          id,
          img
        },
        name,
        status,
        preco,
        oferta,
        qtda,
        pedidoitematributos {
          name,
          value
        }
      },
      gift,
      giftvalor,
      frete,
      notas,
      paymentid
    },
    endereco {
      id,
      cpf,
      celular,
      cep,
      endereco,
      bairro,
      numero,
      cidade,
      uf
    }
  }
}
`
export const searchuserpainel = `
query ($payload: String) {
  SearchUserPainel (payload: $payload) {
    id,
    _id,
    nome,
    sobrenome,
    permissao,
    usuario,
    email,
    tipo,
    status
  } 
}
`
export const searchgiftpainel = `
query ($payload: String) {
  SearchGiftPainel (payload: $payload) {
    id,
    codigo,
    tipo,
    valor,
    validade,
    gastoMin,
    gastoMax,
    emails,
    limiteCupom,
    limiteNprodutos,
    limiteUser,
    freteGratis,
    individual,
    itensVendaDel,
    categorias {
      id,
      active,
      name,
      icon
    },
    categoriasDel {
      id,
      active,
      name,
      icon
    },
    produtos {
      id,
      code,
      tipo,
      name,
      link,
      status,
      preco,
      oferta,
      img {
        id,
        img
      },
      descricao,
      dateOfertaStart,
      dateOfertaEnd,
      categoria,
      gerEstoque,
      statusEstoque,
      estoque,
      pendencia,
      visibilidade,
      visualizacao,
      destaque,
      atributos {
        active,
        id,
        name,
        values {
          active,
          id,
          name,
          selected
        }
      },
      estoqueVariavel {
        id,
        src {
          quantidade,
          values {
            id,
            idParent,
            name,
            value
          }
        }
      },
      dateCreate,
      caracter {
        id,
        name
      },
      qtda
    },
    produtoDel {
      id,
      code,
      tipo,
      name,
      link,
      status,
      preco,
      oferta,
      img {
        id,
        img
      },
      descricao,
      dateOfertaStart,
      dateOfertaEnd,
      categoria,
      gerEstoque,
      statusEstoque,
      estoque,
      pendencia,
      visibilidade,
      visualizacao,
      destaque,
      atributos {
        active,
        id,
        name,
        values {
          active,
          id,
          name,
          selected
        }
      },
      estoqueVariavel {
        id,
        src {
          quantidade,
          values {
            id,
            idParent,
            name,
            value
          }
        }
      },
      dateCreate,
      caracter {
        id,
        name
      },
      qtda
    }
  }
}
`
